import React, { useEffect, useState } from "react";
import user from "../../assets/user.gif";
import DaterangePicker from "../../common/Daterangepicker";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { getHubName } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import {
  Tabs,
  Tab,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import formatDateAndTime from "../../common/formatDateAndTime";
import toast from "react-hot-toast";
import DashboardSkeleton from "../../common/DashboardSkeleton";

export default function Fleetdashboard() {
  const profile = JSON.parse(localStorage.getItem("profile"));
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(today.getDate() - 7);

  const [selectionRange, setSelectionRange] = useState({
    startDate: oneWeekAgo,
    endDate: today,
    key: "selection",
  });
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState("");
  const [hubs, setHubs] = useState(null);
  const [hubsList, setHubsList] = useState(null);
  const [hub, setHub] = useState("");
  const [confirmedBooingList, setConfirmedBookingList] = useState([]);
  const [fleetDelivList, setFleetDelivList] = useState([]);
  const [fleetPickupList, setFleetPickupList] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [overallReportData, setOverallReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  // Pagination state
  const [page, setPage] = useState(0);
  const rowsPerPage = 5;
  const [vendorPaymentsPage, setVendorPaymentsPage] = useState(0);

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const getAllHubListData = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hubs?limit=1000`);
      const data = await response.json();
      if (data) setHubsList(data?.entities?.rows);
    } catch (error) {
      console.error("Error fetching Hub Names:", error);
    }
  };

  const getHubNames = async (value) => {
    const apiDetails = await getHubName(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows || []);
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setCity(value);
    getHubNames(value);
  };

  function formatDateForApi(date, type) {
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());

    let hours = type === "start" ? "00" : "23";
    let minutes = type === "start" ? "00" : "59";

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formattedStartDate = formatDateForApi(
    selectionRange?.startDate,
    "start",
  );
  const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");

  // const bookingDashboards = async (overrideCity = city) => {
  //   let query = `startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
  //   if (overrideCity) query += `&cityId=${overrideCity}`;
  //   if (hub) query += `&hubId=${hub}`;

  //   try {
  //     const response = await fetch(`${apiUrl}/api/bookings/bookingdashboard?${query}`, {
  //       method: "GET",
  //       headers: { "Content-Type": "application/json", Accept: "application/json" },
  //     });
  //     const data = await response.json();
  //     if (data?.statusCode === "0100") {
  //       setConfirmedBookingList(data?.dataValues?.bookingConfirmedList || []);
  //       setPage(0);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching bookings:", error);
  //   }
  // };

  // const fleetDashboardCounts = async (overrideCity = city) => {
  //   let query = `startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
  //   if (overrideCity) query += `&cityId=${overrideCity}`;
  //   if (hub) query += `&hubId=${hub}`;

  //   try {
  //     const response = await fetch(`${apiUrl}/api/reports/delivery-pickup-dashboard?${query}`, {
  //       method: "GET",
  //       headers: { "Content-Type": "application/json", Accept: "application/json" },
  //     });
  //     const data = await response.json();
  //     if (data?.statusCode === "0100") {
  //       setFleetDelivList(data?.entities?.deliveryDashboardList || []);
  //       setFleetPickupList(data?.entities?.pickupDashboardList || []);
  //       setPage(0);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching fleet dashboard:", error);
  //   }
  // };

  const fleetOverviewDashboard = async (overrideCity = city) => {
    let query = `startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
    if (overrideCity) query += `&cityId=${overrideCity}`;
    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/dashboardreports/fleet-overview-dashboard?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setOverallReportData(data?.dataValues || null);
      } else {
        setLoading(false);
        toast.error(data?.message || data?.msg || "An error occurred", {
          position: "top-end",
          style: {
            background: "red",
            color: "white",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching overview report:", error);
    }
  };

  const handleSearch = () => {
    // fleetDashboardCounts();
    // bookingDashboards();
    fleetOverviewDashboard();
  };

  // Run only on initial mount
  useEffect(() => {
    getCityNames();
    getAllHubListData();
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // --- Pagination slice based on active tab ---
  const getActiveData = () => {
    if (tabIndex === 0) return confirmedBooingList;
    if (tabIndex === 1) return fleetDelivList;
    if (tabIndex === 2) return fleetPickupList;
    return [];
  };

  const activeData = getActiveData();
  const paginatedData = activeData.slice(
    page * rowsPerPage,
    (page + 1) * rowsPerPage,
  );

  // Reset page when tab changes
  useEffect(() => {
    setPage(0);
  }, [tabIndex]);

  const expenseList = overallReportData?.costBreakDownObject;
  const expenseListTwo = overallReportData?.expenseList;
  const vendorDetails = overallReportData?.vendorDetails || [];
  const paginatedVendorDetails = vendorDetails.slice(
    vendorPaymentsPage * rowsPerPage,
    (vendorPaymentsPage + 1) * rowsPerPage,
  );

  useEffect(() => {
    setVendorPaymentsPage(0);
  }, [overallReportData]);

  const repairCategories = [
    {
      label: "Running Repair",
      value: Number(expenseListTwo?.totalRunningRepairCostToCompany ?? 0),
      textColor: "text-blue-500",
      bgColor: "bg-blue-500",
    },
    {
      label: "Accident / Insurance",
      value: Number(expenseListTwo?.totalAccidentCostToCompany ?? 0),
      textColor: "text-red-500",
      bgColor: "bg-red-500",
    },
    {
      label: "Trinking & Painting",
      value: Number(
        expenseListTwo?.totalTrinkiringAndPaintingCostToCompany ?? 0,
      ),
      textColor: "text-purple-500",
      bgColor: "bg-purple-500",
    },
    {
      label: "Periodic Maintenance",
      value: Number(expenseListTwo?.totalPeriodicMaintenanceCostToCompany ?? 0),
      textColor: "text-green-500",
      bgColor: "bg-green-500",
    },
    {
      label: "Clutch Repair",
      value: Number(expenseListTwo?.clutchRepairCost ?? 0),
      textColor: "text-orange-500",
      bgColor: "bg-orange-500",
    },
    {
      label: "Battery Repair",
      value: Number(expenseListTwo?.batteryRepairCost ?? 0),
      textColor: "text-cyan-500",
      bgColor: "bg-cyan-500",
    },
    {
      label: "Tyre Repair",
      value: Number(expenseListTwo?.tyresRepairCost ?? 0),
      textColor: "text-yellow-500",
      bgColor: "bg-yellow-500",
    },
    {
      label: "Wind Shield Repair",
      value: Number(expenseListTwo?.windShieldRepairCost ?? 0),
      textColor: "text-indigo-500",
      bgColor: "bg-indigo-500",
    },
    {
      label: "Wheel Alignment / Balancing",
      value: Number(expenseListTwo?.wheelAlignmentBalancingRepairCost ?? 0),
      textColor: "text-pink-500",
      bgColor: "bg-pink-500",
    },
  ];

  const maxRepairCost = Math.max(
    ...repairCategories.map((item) => item.value),
    1,
  );

  return (
    <>{loading ? <><DashboardSkeleton/></> : <><div className="w-full my-8 p-6 flex flex-col justify-start items-start gap-8 bg-white rounded-2xl border border-gray-200 shadow-sm">
      {/* --- HEADER --- */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 w-full">
        <div className="flex items-center gap-4">
          <img className="w-16 h-16 rounded-full" src={user} alt="User" />
          <h1 className="text-2xl font-bold text-gray-800">
            Welcome back, {profile?.name}!
          </h1>
        </div>
      </div>

      {/* <div className="self-stretch flex flex-col justify-start items-start gap-6">
        <div className="self-stretch h-36 inline-flex justify-start items-start gap-4">
          <div className="flex-1 self-stretch p-5 relative bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-center items-start gap-2 overflow-hidden">
            <div className="w-1.5 h-36 left-0 top-0 absolute bg-emerald-700" />
            <div className="justify-start text-gray-500 text-[14px] font-semibold uppercase tracking-wide">
              TOTAL ACTIVE CARS
            </div>
            <div className="justify-start text-emerald-700 text-5xl font-extrabold">
              {overallReportData?.totalVehicleCount ?? 0}
            </div>
          </div>
          <div className="flex-1 self-stretch p-5 relative bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-center items-start gap-2 overflow-hidden">
            <div className="w-1.5 h-36 left-0 top-0 absolute bg-red-700" />
            <div className="justify-start text-gray-500 text-[14px] font-semibold uppercase tracking-wide">
              BLOCKED CARS
            </div>
            <div className="justify-start text-red-700 text-5xl font-extrabold">
              {overallReportData?.totalBlockedVehicleCount ?? 0}
            </div>
          </div>
        </div>
      </div> */}

      {/* --- FILTERS --- */}
      <div className="flex flex-wrap items-center gap-4 w-full bg-white p-4 rounded-xl shadow-sm border border-gray-200">
        <h1 className="text-base font-semibold text-gray-700">Filter By :</h1>
        <div className="min-w-[200px]">
          <DaterangePicker
            selectionRange={selectionRange}
            setSelectionRange={setSelectionRange}
            style={() => {}}
          />
        </div>
        <div className="min-w-[180px]">
          <FormControl fullWidth size="small">
            <InputLabel id="city-select-label">City</InputLabel>
            <Select
              labelId="city-select-label"
              id="city-select"
              value={city}
              label="City"
              onChange={handleCityChange}
            >
              {cities &&
                Object.entries(cities).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
        <div className="flex gap-2 justify-end ml-auto">
          <button
            className="bg-blue-600 text-white px-6 py-2 rounded-full shadow-md hover:bg-blue-700 transition"
            onClick={handleSearch}
          >
            Search
          </button>
          <button
            onClick={() => {
              setCity("");
              setHub("");
              setSelectionRange({
                startDate: oneWeekAgo,
                endDate: today,
                key: "selection",
              });
              setPage(0);

              // Immediately call APIs with cleared parameters
              // bookingDashboards("");
              // fleetDashboardCounts("");
              fleetOverviewDashboard("");
            }}
            className="bg-red-400 text-white px-6 py-2 rounded-full shadow-md hover:bg-gray-500 transition"
          >
            Reset
          </button>
        </div>
      </div>

      {/* 1. TOP STAT STRIP */}
      <div className="self-stretch flex flex-col justify-start items-start gap-6">
        <div className="self-stretch h-36 inline-flex justify-start items-start gap-4">
          <div className="flex-1 self-stretch p-5 relative bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-center items-start gap-2 overflow-hidden">
            <div className="w-1.5 h-36 left-0 top-0 absolute bg-lime-600" />
            <div className="justify-start text-gray-500 text-[14px] font-semibold uppercase tracking-wide">
              OVERDUE PAYMENTS
            </div>
            <div className="justify-start text-lime-600 text-5xl font-extrabold">
              {overallReportData?.paymentDueCount ?? 0}
            </div>
          </div>

          
          <div className="flex-1 self-stretch p-5 relative bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-center items-start gap-2 overflow-hidden">
            <div className="w-1.5 h-36 left-0 top-0 absolute bg-blue-800" />
            <div className="justify-start text-gray-500 text-[14px] font-semibold uppercase tracking-wide">Blocked Cars on Selected Range</div>
            <div className="justify-start text-blue-800 text-5xl font-extrabold">{overallReportData?.totalBlockedVehicleCountBetweenSelectedDates}</div>
          </div>                  

          {/* Repair Cost - COMING SOON */}

          <div className="flex-1 h-36 p-4 relative bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-center items-start gap-2 overflow-hidden">
            <div className="self-stretch justify-start text-gray-500 text-[14px] font-bold uppercase tracking-wide">
              REPAIR COST
            </div>
            <div className="self-stretch justify-start text-red-600 text-2xl font-extrabold">
              {Number(Number(
                overallReportData?.expenseList?.totalRunningRepairCostToCompany,
              ) +
                Number(
                  overallReportData?.expenseList?.totalAccidentCostToCompany,
                ) +
                Number(
                  overallReportData?.expenseList
                    ?.totalTrinkiringAndPaintingCostToCompany,
                ) +
                Number(
                  overallReportData?.expenseList
                    ?.totalPeriodicMaintenanceCostToCompany,
                ) +
                Number(overallReportData?.expenseList?.clutchRepairCost) +
                Number(overallReportData?.expenseList?.batteryRepairCost) +
                Number(overallReportData?.expenseList?.tyresRepairCost) +
                Number(overallReportData?.expenseList?.windShieldRepairCost) +
                Number(
                  overallReportData?.expenseList
                    ?.wheelAlignmentBalancingRepairCost,
                )).toFixed(2)}
            </div>
            <div className="self-stretch justify-start text-zinc-500 text-xs font-normal">
              All vehicles
            </div>
            <div className="w-1.5 h-36 left-[-0.40px] top-0 absolute bg-rose-700" />
          </div>

          {/* <div className="flex-1 self-stretch p-5 relative bg-gray-50 rounded-xl outline outline-1 outline-offset-[-1px] outline-gray-200 flex justify-center items-center overflow-hidden">
            <span className="text-gray-400 text-xs font-semibold uppercase tracking-wide">
              Repair Cost Coming Soon
            </span>
          </div> */}
        </div>
      </div>

      {/* 2. DELIVERY PERFORMANCE SECTION */}
      <div className="self-stretch p-4 rounded-xl flex flex-col justify-start items-start gap-4">
        <div className="justify-start text-slate-500 text-sm font-bold uppercase">
          Delivery Performance
        </div>
        <div className="self-stretch inline-flex justify-start items-start gap-4">
          <div className="flex-1 p-5 bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-3">
            <div className="self-stretch inline-flex justify-start items-center gap-3">
              <div className="size-10 bg-blue-50 rounded-[10px] flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M6.5 12C6.10218 12 5.72064 12.158 5.43934 12.4393C5.15804 12.7206 5 13.1022 5 13.5C5 13.8978 5.15804 14.2794 5.43934 14.5607C5.72064 14.842 6.10218 15 6.5 15C6.89782 15 7.27936 14.842 7.56066 14.5607C7.84196 14.2794 8 13.8978 8 13.5C8 13.1022 7.84196 12.7206 7.56066 12.4393C7.27936 12.158 6.89782 12 6.5 12ZM17.5 12C17.1022 12 16.7206 12.158 16.4393 12.4393C16.158 12.7206 16 13.1022 16 13.5C16 13.8978 16.158 14.2794 16.4393 14.5607C16.7206 14.842 17.1022 15 17.5 15C17.8978 15 18.2794 14.842 18.5607 14.5607C18.842 14.2794 19 13.8978 19 13.5C19 13.1022 18.842 12.7206 18.5607 12.4393C18.2794 12.158 17.8978 12 17.5 12Z"
                    fill="#2563EB"
                  />
                  <path
                    d="M20.7722 9.16174L19.4022 5.06174C19.204 4.46318 18.8216 3.94261 18.3097 3.57442C17.7979 3.20624 17.1827 3.0093 16.5522 3.01174H7.44219C6.81203 3.01082 6.19758 3.20836 5.68601 3.57632C5.17444 3.94429 4.79174 4.46401 4.59219 5.06174L3.22219 9.16174C2.50219 9.46174 1.99219 10.1817 1.99219 11.0017V16.0017C1.99219 16.7417 2.40219 17.3817 2.99219 17.7217V20.0017C2.99219 20.5517 3.44219 21.0017 3.99219 21.0017H4.99219C5.54219 21.0017 5.99219 20.5517 5.99219 20.0017V18.0017H17.9922V20.0017C17.9922 20.5517 18.4422 21.0017 18.9922 21.0017H19.9922C20.5422 21.0017 20.9922 20.5517 20.9922 20.0017V17.7217C21.2945 17.5472 21.5458 17.2967 21.7212 16.9949C21.8967 16.6932 21.9901 16.3508 21.9922 16.0017V11.0017C21.9922 10.1717 21.4822 9.46174 20.7622 9.16174H20.7722ZM7.44219 5.00174H16.5622C16.7718 5.0012 16.9763 5.06656 17.1468 5.18858C17.3173 5.31061 17.4451 5.48312 17.5122 5.68174L18.6222 9.00174H5.39219L6.50219 5.68174C6.56927 5.48312 6.69709 5.31061 6.86756 5.18858C7.03803 5.06656 7.24254 5.0012 7.45219 5.00174H7.44219ZM4.00219 16.0017V11.0017H20.0022V16.0017H4.00219Z"
                    fill="#2563EB"
                  />
                </svg>
              </div>
              <div className="justify-start text-slate-500 text-xs font-semibold uppercase">
                Delivery Count
              </div>
            </div>
            <div className="justify-start text-gray-900 text-3xl font-extrabold">
              {overallReportData?.totalDelivery ?? 0}
            </div>
          </div>
          <div className="flex-1 p-5 bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-3">
            <div className="self-stretch inline-flex justify-start items-center gap-3">
              <div className="size-10 bg-emerald-100 rounded-[10px] flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M18.1669 8.33357C18.5474 10.2013 18.2762 12.1431 17.3984 13.8351C16.5206 15.527 15.0893 16.8669 13.3431 17.6313C11.597 18.3957 9.64154 18.5384 7.80293 18.0355C5.96433 17.5327 4.35368 16.4147 3.23958 14.8681C2.12548 13.3214 1.57529 11.4396 1.68074 9.53639C1.78619 7.63318 2.54092 5.82364 3.81906 4.40954C5.0972 2.99545 6.8215 2.06226 8.7044 1.76561C10.5873 1.46897 12.515 1.82679 14.166 2.7794M7.49967 9.1665L9.99967 11.6665L18.333 3.33317"
                    stroke="#10B981"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="justify-start text-slate-500 text-xs font-semibold uppercase">
                On-Time Deliveries
              </div>
            </div>
            <div className="justify-start text-gray-900 text-3xl font-extrabold">
              {overallReportData?.onTimeDeliveryCount ?? 0}
            </div>
          </div>
          <div className="flex-1 p-5 bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-3">
            <div className="self-stretch inline-flex justify-start items-center gap-3">
              <div className="size-10 bg-orange-100 rounded-[10px] flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10 4.99962V10L13.3336 11.6668M18.334 10C18.334 14.6028 14.6028 18.334 10 18.334C5.39727 18.334 1.66602 14.6028 1.66602 10C1.66602 5.39727 5.39727 1.66602 10 1.66602C14.6028 1.66602 18.334 5.39727 18.334 10Z"
                    stroke="#F97316"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="justify-start text-slate-500 text-xs font-semibold uppercase">
                Late Deliveries
              </div>
            </div>
            <div className="justify-start text-gray-900 text-3xl font-extrabold">
              {overallReportData?.lateDeliveryCount ?? 0}
            </div>
          </div>
        </div>
        <div className="self-stretch inline-flex justify-start items-start gap-4">
          <div className="flex-1 p-5 bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-3">
            <div className="self-stretch inline-flex justify-start items-center gap-3">
              <div className="size-10 bg-sky-300/50 rounded-[10px] flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <g clipPath="url(#clip0_126_1227)">
                    <path
                      d="M10 4.99962V10L13.3336 11.6668M18.334 10C18.334 14.6028 14.6028 18.334 10 18.334C5.39727 18.334 1.66602 14.6028 1.66602 10C1.66602 5.39727 5.39727 1.66602 10 1.66602C14.6028 1.66602 18.334 5.39727 18.334 10Z"
                      stroke="#000E8E"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_126_1227">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="justify-start text-slate-500 text-xs font-semibold uppercase">
                Pickup Count
              </div>
            </div>
            <div className="justify-start text-gray-900 text-3xl font-extrabold">
              {overallReportData?.totalPickup ?? 0}
            </div>
          </div>
          <div className="flex-1 p-5 bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-3">
            <div className="self-stretch inline-flex justify-start items-center gap-3">
              <div className="size-10 bg-emerald-100 rounded-[10px] flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M18.1669 8.33357C18.5474 10.2013 18.2762 12.1431 17.3984 13.8351C16.5206 15.527 15.0893 16.8669 13.3431 17.6313C11.597 18.3957 9.64154 18.5384 7.80293 18.0355C5.96433 17.5327 4.35368 16.4147 3.23958 14.8681C2.12548 13.3214 1.57529 11.4396 1.68074 9.53639C1.78619 7.63318 2.54092 5.82364 3.81906 4.40954C5.0972 2.99545 6.8215 2.06226 8.7044 1.76561C10.5873 1.46897 12.515 1.82679 14.166 2.7794M7.49967 9.1665L9.99967 11.6665L18.333 3.33317"
                    stroke="#10B981"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="justify-start text-slate-500 text-xs font-semibold uppercase">
                On-Time Pickup
              </div>
            </div>
            <div className="justify-start text-gray-900 text-3xl font-extrabold">
              {overallReportData?.onTimePickupCount ?? 0}
            </div>
          </div>
          <div className="flex-1 p-5 bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-3">
            <div className="self-stretch inline-flex justify-start items-center gap-3">
              <div className="size-10 bg-orange-100 rounded-[10px] flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <g clipPath="url(#clip0_126_1241)">
                    <path
                      d="M10 4.99962V10L13.3336 11.6668M18.334 10C18.334 14.6028 14.6028 18.334 10 18.334C5.39727 18.334 1.66602 14.6028 1.66602 10C1.66602 5.39727 5.39727 1.66602 10 1.66602C14.6028 1.66602 18.334 5.39727 18.334 10Z"
                      stroke="#F97316"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_126_1241">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="justify-start text-slate-500 text-xs font-semibold uppercase">
                Late pickup
              </div>
            </div>
            <div className="justify-start text-gray-900 text-3xl font-extrabold">
              {overallReportData?.latePickupCount ?? 0}
            </div>
          </div>
        </div>
      </div>

      {/* 3. TOTAL COST BREAKDOWN SECTION */}
      <div className="self-stretch inline-flex justify-start items-start gap-2">
        <div className="flex-1 p-5 rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-4 overflow-hidden">
          <div className="justify-start text-gray-500 text-xs font-bold uppercase tracking-wide">
            TOTAL COST BREAKDOWN
          </div>
          <div className="self-stretch flex flex-col justify-start items-start gap-4">
            <div className="self-stretch inline-flex justify-start items-start gap-4">
              {/* PMS */}
              <div className="flex-1 p-4 bg-white rounded-xl border-l border-r border-t border-b-4 border-zinc-100 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-gray-900 text-lg font-semibold tracking-tight">
                    PMS
                  </div>
                  <div className="justify-start text-gray-500 text-xs font-semibold">
                    Count: {expenseList?.periodicMaintenance?.totalCount ?? 0}
                  </div>
                </div>
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-emerald-500 text-xs font-semibold">
                    Paid ₹
                    {(
                      expenseList?.periodicMaintenance?.totalAmoountPaid ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                  <div className="justify-end text-red-500 text-xs font-semibold">
                    Unpaid ₹{" "}
                    {(
                      expenseList?.periodicMaintenance?.pendingCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                  {/* Deductions not available yet
                  <div className="px-2.5 py-1 bg-red-100 rounded-[999px] outline outline-1 outline-offset-[-1px] outline-red-300 flex justify-center items-center">
                    <div className="justify-start text-red-600 text-xs font-bold">- ₹0</div>
                  </div>
                  */}
                </div>
                <div className="self-stretch h-px bg-gray-200" />
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="w-16 self-stretch justify-start text-gray-500 text-xs font-bold uppercase tracking-wide">
                    TOTAL
                  </div>
                  <div className="justify-start text-gray-900 text-lg font-extrabold">
                    ₹
                    {(
                      expenseList?.periodicMaintenance?.totalCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>

              {/* Accidents */}
              <div className="flex-1 p-4 bg-white rounded-xl border-l border-r border-t border-b-4 border-zinc-100 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-gray-900 text-lg font-semibold tracking-tight">
                    Accidents
                  </div>
                  <div className="justify-start text-gray-500 text-xs font-semibold">
                    Count: {expenseList?.accidentCases?.totalCount ?? 0}
                  </div>
                </div>
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-emerald-500 text-xs font-semibold">
                    Paid ₹
                    {(
                      expenseList?.accidentCases?.totalAmoountPaid ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                  <div className="justify-end text-red-500 text-xs font-semibold">
                    Unpaid ₹{" "}
                    {(
                      expenseList?.accidentCases?.pendingCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
                <div className="self-stretch h-px bg-gray-200" />
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="flex-1 self-stretch justify-start text-gray-500 text-xs font-bold uppercase tracking-wide">
                    TOTAL
                  </div>
                  <div className="justify-start text-gray-900 text-lg font-extrabold">
                    ₹
                    {(
                      expenseList?.accidentCases?.totalCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>

              {/* Running Repairs */}
              <div className="flex-1 p-4 bg-white rounded-xl border-l border-r border-t border-b-4 border-zinc-100 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-gray-900 text-lg font-semibold tracking-tight">
                    Running Repairs
                  </div>
                  <div className="justify-start text-gray-500 text-xs font-semibold">
                    Count: {expenseList?.runningRepair?.totalCount ?? 0}
                  </div>
                </div>
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-emerald-500 text-xs font-semibold">
                    Paid ₹
                    {(
                      expenseList?.runningRepair?.totalCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                  <div className="justify-end text-red-500 text-xs font-semibold">
                    Unpaid ₹
                    {(
                      expenseList?.runningRepair?.pendingCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
                <div className="self-stretch h-px bg-gray-200" />
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="w-40 self-stretch justify-start text-gray-500 text-xs font-bold uppercase tracking-wide">
                    TOTAL
                  </div>
                  <div className="justify-start text-gray-900 text-lg font-extrabold">
                    ₹
                    {(
                      expenseList?.runningRepair?.totalCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>
            </div>

            <div className="self-stretch inline-flex justify-start items-start gap-4">
              <div className="flex-1 p-4 bg-white rounded-xl border-l border-r border-t border-b-4 border-zinc-100 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-gray-900 text-lg font-semibold tracking-tight">
                    Wheel Alignment / Balancing
                  </div>
                  <div className="justify-start text-gray-500 text-xs font-semibold">
                    Count:{" "}
                    {expenseList?.wheelAlignmentBalancingRepair?.totalCount ??
                      0}
                  </div>
                </div>
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-emerald-500 text-xs font-semibold">
                    Paid ₹
                    {(
                      expenseList?.wheelAlignmentBalancingRepair?.totalCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                  <div className="justify-end text-red-500 text-xs font-semibold">
                    Unpaid ₹
                    {(
                      expenseList?.wheelAlignmentBalancingRepair?.pendingCost ??
                      0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
                <div className="self-stretch h-px bg-gray-200" />
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="w-40 self-stretch justify-start text-gray-500 text-xs font-bold uppercase tracking-wide">
                    TOTAL
                  </div>
                  <div className="justify-start text-gray-900 text-lg font-extrabold">
                    ₹
                    {(
                      expenseList?.wheelAlignmentBalancingRepair?.totalCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>

              <div className="flex-1 p-4 bg-white rounded-xl border-l border-r border-t border-b-4 border-zinc-100 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-gray-900 text-lg font-semibold tracking-tight">
                    Wind Shield Repair
                  </div>
                  <div className="justify-start text-gray-500 text-xs font-semibold">
                    Count: {expenseList?.windShieldRepair?.totalCount ?? 0}
                  </div>
                </div>
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-emerald-500 text-xs font-semibold">
                    Paid ₹
                    {(
                      expenseList?.windShieldRepair?.totalCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                  <div className="justify-end text-red-500 text-xs font-semibold">
                    Unpaid ₹
                    {(
                      expenseList?.windShieldRepair?.pendingCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
                <div className="self-stretch h-px bg-gray-200" />
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="w-40 self-stretch justify-start text-gray-500 text-xs font-bold uppercase tracking-wide">
                    TOTAL
                  </div>
                  <div className="justify-start text-gray-900 text-lg font-extrabold">
                    ₹
                    {(
                      expenseList?.windShieldRepair?.totalCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>

              {/* Tinkering & Painting */}
              <div className="flex-1 p-4 bg-white rounded-xl border-l border-r border-t border-b-4 border-zinc-100 inline-flex flex-col justify-start items-start gap-3 min-h-[120px]">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-gray-900 text-lg font-semibold tracking-tight">
                    Tinkering &amp; Painting
                  </div>
                  <div className="justify-start text-gray-500 text-xs font-semibold">
                    Count: {expenseList?.trinkiringAndPainting?.totalCount ?? 0}
                  </div>
                </div>
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-emerald-500 text-xs font-semibold">
                    Paid ₹
                    {(
                      expenseList?.trinkiringAndPainting?.totalAmoountPaid ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                  <div className="justify-end text-red-500 text-xs font-semibold">
                    Unpaid ₹
                    {(
                      expenseList?.trinkiringAndPainting?.pendingCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
                <div className="self-stretch h-px bg-gray-200" />
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="flex-1 self-stretch justify-start text-gray-500 text-xs font-bold uppercase tracking-wide">
                    TOTAL
                  </div>
                  <div className="justify-start text-gray-900 text-lg font-extrabold">
                    ₹
                    {(
                      expenseList?.trinkiringAndPainting?.totalCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>
            </div>

            <div className="self-stretch inline-flex justify-start items-start gap-4">
              <div className="flex-1 p-4 bg-white rounded-xl border-l border-r border-t border-b-4 border-zinc-100 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-gray-900 text-lg font-semibold tracking-tight">
                    Tyres
                  </div>
                  <div className="justify-start text-gray-500 text-xs font-semibold">
                    Count: {expenseList?.tyresRepair?.totalCount ?? 0}
                  </div>
                </div>
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-emerald-500 text-xs font-semibold">
                    Paid ₹
                    {(expenseList?.tyresRepair?.totalCost ?? 0).toLocaleString(
                      "en-IN",
                    )}
                  </div>
                  <div className="justify-end text-red-500 text-xs font-semibold">
                    Unpaid ₹
                    {(
                      expenseList?.tyresRepair?.pendingCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
                <div className="self-stretch h-px bg-gray-200" />
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="w-40 self-stretch justify-start text-gray-500 text-xs font-bold uppercase tracking-wide">
                    TOTAL
                  </div>
                  <div className="justify-start text-gray-900 text-lg font-extrabold">
                    ₹
                    {(expenseList?.tyresRepair?.totalCost ?? 0).toLocaleString(
                      "en-IN",
                    )}
                  </div>
                </div>
              </div>

              <div className="flex-1 p-4 bg-white rounded-xl border-l border-r border-t border-b-4 border-zinc-100 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-gray-900 text-lg font-semibold tracking-tight">
                    Clutch
                  </div>
                  <div className="justify-start text-gray-500 text-xs font-semibold">
                    Count: {expenseList?.clutchRepair?.totalCount ?? 0}
                  </div>
                </div>
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-emerald-500 text-xs font-semibold">
                    Paid ₹
                    {(expenseList?.clutchRepair?.totalCost ?? 0).toLocaleString(
                      "en-IN",
                    )}
                  </div>
                  <div className="justify-end text-red-500 text-xs font-semibold">
                    Unpaid ₹
                    {(
                      expenseList?.clutchRepair?.pendingCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
                <div className="self-stretch h-px bg-gray-200" />
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="w-40 self-stretch justify-start text-gray-500 text-xs font-bold uppercase tracking-wide">
                    TOTAL
                  </div>
                  <div className="justify-start text-gray-900 text-lg font-extrabold">
                    ₹
                    {(expenseList?.clutchRepair?.totalCost ?? 0).toLocaleString(
                      "en-IN",
                    )}
                  </div>
                </div>
              </div>

              <div className="flex-1 p-4 bg-white rounded-xl border-l border-r border-t border-b-4 border-zinc-100 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-gray-900 text-lg font-semibold tracking-tight">
                    Batteries
                  </div>
                  <div className="justify-start text-gray-500 text-xs font-semibold">
                    Count: {expenseList?.batteryRepair?.totalCount ?? 0}
                  </div>
                </div>
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-emerald-500 text-xs font-semibold">
                    Paid ₹
                    {(
                      expenseList?.batteryRepair?.totalCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                  <div className="justify-end text-red-500 text-xs font-semibold">
                    Unpaid ₹
                    {(
                      expenseList?.batteryRepair?.pendingCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
                <div className="self-stretch h-px bg-gray-200" />
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="w-40 self-stretch justify-start text-gray-500 text-xs font-bold uppercase tracking-wide">
                    TOTAL
                  </div>
                  <div className="justify-start text-gray-900 text-lg font-extrabold">
                    ₹
                    {(
                      expenseList?.batteryRepair?.totalCost ?? 0
                    ).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="self-stretch p-5 bg-orange-50 rounded-xl border-l border-r border-t border-b-4 border-amber-500 inline-flex justify-between items-center">
            <div className="justify-start text-yellow-800 text-2xl font-bold">
              GRAND TOTAL
            </div>
            <div className="inline-flex flex-col justify-center items-end gap-2">
              <div className="justify-start text-gray-900 text-3xl font-black">
                ₹
                {(
                  Number(expenseList?.periodicMaintenance?.pendingCost ?? 0) +
                  Number(expenseList?.runningRepair?.pendingCost ?? 0) +
                  Number(expenseList?.accidentCases?.pendingCost ?? 0) +
                  Number(expenseList?.trinkiringAndPainting?.pendingCost ?? 0) +
                  Number(expenseList?.batteryRepair?.totalCost ?? 0) +
                  Number(expenseList?.tyresRepair?.pendingCost ?? 0) +
                  Number(expenseList?.windShieldRepair?.pendingCost ?? 0) +
                  Number(
                    expenseList?.wheelAlignmentBalancingRepair?.pendingCost ??
                      0,
                  )
                ).toLocaleString("en-IN")}
              </div>
              <div className="justify-start text-red-600 text-xs font-semibold">
                Pending Payment
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 4. CUSTOMER FEEDBACK SECTION */}
      <div className="self-stretch inline-flex justify-start items-start gap-8">
        <div className="flex-1 p-4 bg-white/50 rounded-xl outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-4">
          <div className="justify-start text-slate-500 text-sm font-bold uppercase">
            Customer Feedback
          </div>
          {/* COMING SOON OVERLAY/BLOCK */}
          <div className="self-stretch flex-1 bg-gray-50 rounded-xl p-4 min-h-[150px]">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 h-full">
              {/* Card 1 */}
              <div className="bg-green-200 rounded-xl border border-gray-200 p-4 shadow-sm flex flex-col justify-between">
                <div>
                  <p className="text-xs font-semibold uppercase tracking-wide">
                    Total Reviews
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900 mt-2">
                    {overallReportData?.totalReviews}
                  </h3>
                </div>
              </div>

              {/* Card 2 */}
              <div className="bg-red-200 rounded-xl border border-gray-200 p-4 shadow-sm flex flex-col justify-between">
                <div>
                  <p className="text-xs font-semibold uppercase tracking-wide">
                    Total Reviews Rejected
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900 mt-2">
                    {overallReportData?.totalReviewRejected}
                  </h3>
                </div>
              </div>

              {/* Card 3 */}
              <div className="bg-purple-200 rounded-xl border border-gray-200 p-4 shadow-sm flex flex-col justify-between">
                <div>
                  <p className="text-xs font-semibold uppercase tracking-wide">
                    Pending for Verification
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900 mt-2">
                    {overallReportData?.totalReviewPendingForVerification}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 5. PERFORMANCE ANALYTICS */}
      {/* <div className="self-stretch p-4 bg-white/50 rounded-xl outline outline-1 outline-offset-[-1px] outline-gray-200 flex flex-col justify-start items-start gap-4">
        <div className="justify-start text-slate-500 text-sm font-bold uppercase">
          Performance Analytics
        </div>
        <div className="self-stretch inline-flex justify-start items-start gap-4">
          <div className="flex-1 p-6 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-5">
            <div className="self-stretch inline-flex justify-between items-center">
              <div className="flex-1 inline-flex flex-col justify-start items-start gap-1">
                <div className="justify-start text-gray-900 text-base font-bold">
                  Deliveries vs Pickups
                </div>
                <div className="self-stretch justify-start text-gray-500 text-xs font-normal">
                  Daily volume comparison across the fleet
                </div>
              </div>
            </div>

            <div className="self-stretch h-60 bg-gray-50 rounded-xl outline outline-1 outline-offset-[-1px] outline-gray-200 flex justify-center items-center overflow-hidden">
              <span className="text-gray-400 text-sm font-semibold uppercase tracking-wide">
                Coming Soon
              </span>
            </div>
          </div>
        </div>
      </div> */}

      <div className="self-stretch inline-flex justify-start items-start gap-2.5">
        <div className="flex-1 self-stretch p-5 bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-3.5 overflow-hidden">
          <div className="w-full justify-start text-gray-500 text-xs font-bold uppercase tracking-wide mb-4">
            Repair Category Spend
          </div>
          {repairCategories.map((category) => {
            const percentage =
              maxRepairCost > 0 ? (category.value / maxRepairCost) * 100 : 0;

            return (
              <div
                key={category.label}
                className="self-stretch flex flex-col justify-start items-start gap-1"
              >
                {/* Label + Amount */}
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="text-gray-500 text-xs font-normal font-['Inter']">
                    {category.label}
                  </div>

                  <div
                    className={`${category.textColor} text-xs font-bold font-['Inter']`}
                  >
                    ₹{category.value.toLocaleString("en-IN")}
                  </div>
                </div>

                {/* Progress Bar */}
                <div className="self-stretch h-1.5 bg-gray-200 rounded-[3px] flex justify-start items-start overflow-hidden">
                  <div
                    className={`${category.bgColor} h-1.5 rounded-[3px] transition-all duration-500`}
                    style={{
                      width: `${percentage}%`,
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>

        <div className="self-stretch bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start overflow-hidden">
          <div className="self-stretch h-12 px-6 py-3.5 bg-gray-50 border-b border-gray-200 inline-flex justify-between items-center">
            <div className="text-gray-500 text-xs font-bold font-['Inter'] uppercase tracking-wide">
              Vendor Payments
            </div>
          </div>

          <div className="self-stretch h-9 bg-white border-b border-gray-200 inline-flex justify-start items-start">
            <div className="w-56 pl-6 pr-4 py-2.5 flex justify-start items-start">
              <div className="text-gray-500 text-[10px] font-bold font-['Inter'] uppercase tracking-wide">
                Vendor
              </div>
            </div>

            <div className="w-28 px-4 py-2.5 flex justify-start items-start">
              <div className="text-gray-500 text-[10px] font-bold font-['Inter'] uppercase tracking-wide">
                Total Paid
              </div>
            </div>

            <div className="w-28 px-4 py-2.5 flex justify-start items-start">
              <div className="text-gray-500 text-[10px] font-bold font-['Inter'] uppercase tracking-wide">
                Outstanding
              </div>
            </div>

            <div className="flex-1 px-4 py-2.5 flex justify-center items-center">
              <div className="text-gray-500 text-[10px] font-bold font-['Inter'] uppercase tracking-wide">
                Status
              </div>
            </div>
          </div>

          {/* Vendor Payments */}
          {vendorDetails.length > 0 ? (
            paginatedVendorDetails.map((vendor) => {
              const isPaid = vendor?.status?.toLowerCase() === "paid";
              const pendingAmount = Number(vendor?.pendingAmount || 0);

              return (
                <div
                  key={vendor?.vendorId}
                  className="self-stretch min-h-12 border-b border-gray-200 inline-flex justify-start items-start"
                >
                  {/* Vendor Name */}
                  <div className="w-56 pl-6 pr-4 py-3 flex justify-start items-start">
                    <div className="text-neutral-800 text-xs font-semibold font-['Inter'] capitalize">
                      {vendor?.vendorName || "-"}
                    </div>
                  </div>

                  <div className="w-28 pl-6 pr-4 py-3 flex justify-start items-start">
                    <div className="text-neutral-800 text-xs font-semibold font-['Inter'] capitalize">
                      {vendor?.totalAmountPaid || "-"}
                    </div>
                  </div>

                  {/* Outstanding Amount */}
                  <div className="w-28 px-4 py-3 flex justify-start items-start">
                    <div
                      className={`text-xs font-semibold font-['Inter'] ${
                        isPaid ? "text-green-500" : "text-amber-500"
                      }`}
                    >
                      ₹{pendingAmount.toLocaleString("en-IN")}
                    </div>
                  </div>

                  {/* Status */}
                  <div className="flex-1 px-4 py-3 flex justify-center items-center">
                    <div
                      className={`px-2.5 py-1 rounded-[999px] flex justify-start items-start ${
                        isPaid ? "bg-green-500/10" : "bg-amber-500/10"
                      }`}
                    >
                      <div
                        className={`text-xs font-bold font-['Inter'] uppercase ${
                          isPaid ? "text-green-500" : "text-amber-500"
                        }`}
                      >
                        {vendor?.status || "Pending"}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="self-stretch px-6 py-6 flex justify-center items-center">
              <div className="text-gray-400 text-xs font-medium font-['Inter']">
                No vendor payments found
              </div>
            </div>
          )}

          {vendorDetails.length > rowsPerPage && (
            <TablePagination
              component="div"
              count={vendorDetails.length}
              page={vendorPaymentsPage}
              onPageChange={(_, nextPage) => setVendorPaymentsPage(nextPage)}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[]}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} of ${count}`
              }
            />
          )}
        </div>
      </div>
    </div></>}</>
  );
}
